import React from 'react';
import dayjs from "dayjs";
import {capitaliseFirst} from "../../../assets/scripts/string-functions";

function SussdProofOfFunds(props) {
    const gapHeight = 30
    return (
        <document height="a4" group-gap={10}>
            <group>
                <header>
                    Confirmation of Proof of Funds
                </header>
                <border color="green" height={4}/>
                <gap size={gapHeight}/>
                <string>{dayjs().format('D MMM YYYY')}</string>
                <gap size={gapHeight}/>
                <string>{props.addressee}</string>
                <gap size={gapHeight}/>
                <grid columns={[1,23]} >
                    <row>
                        <cell padding-left="0" padding-right="0" padding-top="0" padding-bottom="0">
                            <string font-size={10} color="green">RE:</string>
                        </cell>
                        <cell padding-left="0" padding-right="0" padding-top="0" padding-bottom="0">
                            <string font-size={10} color="green">{props.applicationTitle}</string>
                        </cell>
                    </row>
                    <row>
                        <cell padding-left="0" padding-right="0" padding-top="0" padding-bottom="0">

                        </cell>
                        <cell padding-left="0" padding-right="0" padding-top="0" padding-bottom="0">
                            <string font-size={10} color="green">Purchase of {props.addressToPurchase}</string>
                        </cell>
                    </row>
                </grid>
                <gap size={gapHeight}/>
                <string>{`Dear ${props.addresseeFirstName},`}</string>
                <gap/>
                <string>I am assisting {props.applicationTitle} with {props.applicationPossessive.toLowerCase()} mortgage.</string>
                <gap/>
                <string>{`${capitaliseFirst(props.applicationPossessive)} funding position is more than adequate, should ${props.applicationPreposition.toLowerCase()} wish to purchase ${props.addressToPurchase}.`}</string>
                <gap/>
                <string>This letter is provided as proof of funding. If any clarification is required, please don't hesitate to contact me on kevin@sussd.ie or 086-3836155.</string>
                <gap/>
                <string>Yours sincerely,</string>
                <gap size={21}/>
                <kevinsignature/>
                <string>___________________________</string>
                <string>Kevin Coakley</string>
                <gap/>
                <string>Director</string>
                <string>Suss'd Mortgages</string>
            </group>
        </document>
    );
}

export default SussdProofOfFunds;